<!--
 * @Description: 发票出具
 * @Author: luzx
 * @Date: 2023-07-03 14:09:06
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-07-06 14:08:39
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <div class="header_right" @click="showCardNav = !showCardNav">
        <div class="title">搜索</div>
        <div>
          <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
            <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
          </div>
        </div>
      </div>
      <div v-show="showCardNav" class="hr"></div>
      <el-collapse-transition>
        <div v-show="showCardNav">
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">票号：</span>
              <el-input v-model="tableParam.ticketNumber" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-left: 24px">
              <span style="margin-right: 12px">财务编码:</span>
              <el-input v-model="tableParam.financialCode" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-left: 24px">
              <span style="margin-right: 12px">月份：</span>
              <el-date-picker
                v-model="startTimDateEndTimDate"
                type="monthrange"
                unlink-panels
                value-format="yyyy-MM"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                @change="(tableParam.startMonth = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.endMonth = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"
              ></el-date-picker>
            </span>
            <span style="display: inline-block; margin-left: 24px">
              <span style="margin-right: 12px">日期：</span>
              <el-date-picker
                v-model="startTimDateEndTimDate2"
                type="daterange"
                unlink-panels
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="(tableParam.startInvoicingData = startTimDateEndTimDate2 ? startTimDateEndTimDate2[0] : ''), (tableParam.endInvoicingData = startTimDateEndTimDate2 ? startTimDateEndTimDate2[1] : '')"
              ></el-date-picker>
            </span>
            <span style="display: inline-block; margin-left: 24px">
              <span style="margin-right: 12px">工程名称:</span>
              <el-input v-model="tableParam.engineeringName" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-left: 24px">
              <span style="margin-right: 12px">开票人：</span>
              <el-input v-model="tableParam.saller" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">开票金额:</span>
              <el-input v-model="tableParam.startInvoiceAmount" style="width: 200px" clearable placeholder="请输入" />至<el-input v-model="tableParam.endInvoiceAmount" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-right: 24px; margin-bottom: 10px">
              <span style="margin-right: 12px; display: inline-block; width: 70px; text-align: right">发票金额:</span>
              <el-input v-model="tableParam.billIssuedTotalMoney" style="width: 200px" clearable placeholder="请输入" />至<el-input v-model="tableParam.invoiceAmount" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <span style="display: inline-block; margin-left: 24px">
              <span style="margin-right: 12px">合同单位:</span>
              <el-input v-model="tableParam.contractUnit" style="width: 200px" clearable placeholder="请输入" />
            </span>
            <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
          </div>
        </div>
      </el-collapse-transition>
      <div class="hr"></div>
      <el-main style="display: flex">
        <div>
          <!-- <div class="card scroll"> -->
          <div class="card">
            <div class="card_nav">
              <div style="display: flex; align-items: center">
                <!-- <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='TIANJIA'))!==-1" size="small" class="bottom_all" style="margin-left: 0" @click="addcard"> -->
                <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small" class="bottom_all" style="margin-left: 0" @click="addcard(), (disabledType = false), (opType = 'add')">
                  添加开票
                </el-button>
                <!-- <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='SHANCHU'))!==-1" size="small" class="bottom_two" @click="delHandler"> -->
                <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'SHANCHU') !== -1" size="small" class="bottom_two" @click="delHandler"> 删除 </el-button>
                <div style="margin-left: 10px; color: red; font-weight: bold"><span style="">发票金额(含税价)合计：</span>{{ tableData[0] ? (tableData[0].totalMoney ? numFormat(tableData[0].totalMoney) : 0) : 0 }} 元</div>
                <!-- <div style="margin-left: 10px; color: red; font-weight: bold">
                  <span style="">已开票金额含税价：</span>{{ tableData[0] ? (tableData[0].billIssuedTotalMoney ? numFormat(tableData[0].billIssuedTotalMoney) : 0) : 0 }} 元
                </div> -->
              </div>
              <div>
                <el-button size="medium" class="bottom_all" style="margin-left: 12px" @click="load()">导 出</el-button>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed="item.label == '操作' ? 'right' : false">
                    <template slot-scope="scope">
                      <span v-if="item.label == '是否红冲'">
                        <span v-if="scope.row.sureHongchong == 0" style="color: #969799">否</span>
                        <span v-else-if="scope.row.sureHongchong == 1" style="color: #00a754">是</span>
                      </span>
                      <span v-else-if="item.label == '红冲类型'">
                        <span v-if="scope.row.hongchongType == 1">本月</span>
                        <span v-else-if="scope.row.hongchongType == 2">往期</span>
                      </span>
                      <span v-else-if="item.label == '附件'">
                        <a class="table_link" :href="'/file/' + scope.row.annexUrl" :download="scope.row.annexName">{{ scope.row.annexName }}</a>
                      </span>
                      <span v-else-if="item.label == '状态'">
                        <span v-if="scope.row.dataStatus == 0" style="color: #969799">未开票</span>
                        <span v-else-if="scope.row.dataStatus == 1" style="color: #00a754">已开票</span>
                      </span>
                      <div v-else-if="item.label == '操作'">
                        <el-button
                          v-if="ButtonList.findIndex(res => res.buttonValue == 'GONGCHENXINXI') !== -1"
                          class="bottom_one"
                          size="mini"
                          @click="lookcard(scope.row), (disabledType = false), (opType = 'edit'), (selectData = scope.row)"
                        >
                          工程信息
                        </el-button>
                        <el-button class="bottom_one" size="mini" @click="addOtherCard(scope.row)"> 开票信息 </el-button>
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 添加开票 -->
    <el-dialog :visible.sync="addDialog" width="600px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div>
        <el-form ref="reffromDate" class="reffromDom" :rules="rules" :model="fromDate" label-width="160px">
          <div class="bill_title">财务信息：</div>
          <el-form-item label="工程名称：" prop="engineeringId">
            <el-select v-model="fromDate.engineeringId" style="width: 340px" placeholder="请选择" :disabled="isDetails" filterable @change="changstatus">
              <el-option v-for="(item, index) in engineeringNameList" :key="index" :label="item.engineeringName" :value="item.engineeringId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="财务编码：">
            <el-input v-model="fromDate.financialCode" style="width: 340px" disabled clearable placeholder="自动带出" />
          </el-form-item>
          <el-form-item label="开票人：">
            <el-input v-if="fromDate.engineeringId != '1'" v-model="fromDate.saller" style="width: 340px" disabled clearable placeholder="自动带出" />
            <el-cascader
              v-else
              ref="sallerId"
              v-model="fromDate.sallerId"
              style="width: 340px"
              popper-class="loading"
              :disabled="isDetails"
              :options="principalarr"
              :show-all-levels="false"
              :props="{ value: 'id', label: 'name', emitPath: false }"
              filterable
              @visible-change="visibleChange"
              @change="changeSaller"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="处别：">
            <el-input v-model="fromDate.sallerDivision" style="width: 340px" disabled clearable placeholder="自动带出" />
          </el-form-item>
          <el-form-item label="合同单位：">
            <el-input v-model="fromDate.contractUnit" style="width: 340px" disabled clearable placeholder="自动带出" />
          </el-form-item>
          <el-form-item label="合同签订主体：">
            <el-input v-model="fromDate.contractSigningEntity" style="width: 340px" disabled clearable placeholder="自动带出" />
          </el-form-item>
          <el-form-item label="开票主体：" prop="invoicingSubject">
            <el-input v-model="fromDate.invoicingSubject" style="width: 340px" :disabled="isDetails" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item label="已开票金额：" prop="invoicedAmount">
            <el-input v-model="fromDate.invoicedAmount" style="width: 340px" disabled clearable>
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="不含税金额：">
            <el-input v-model="fromDate.amountExcludingTax" style="width: 340px" disabled clearable placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="税额：">
            <el-input v-model="fromDate.taxAmount" style="width: 340px" disabled clearable placeholder="请输入">
            </el-input>
          </el-form-item>
          <template v-if="isDetails">
            <div class="bill_title">销售信息：</div>
            <el-form-item label="月份：" prop="invoicingMonth">
              <el-date-picker v-model="fromDate.invoicingMonth" type="month" format="yyyy-MM" value-format="yyyy-MM" style="width: 340px" placeholder="选择月"> </el-date-picker>
            </el-form-item>
            <el-form-item label="日期：" prop="invoicingData">
              <el-date-picker v-model="fromDate.invoicingData" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 340px" placeholder="选择日期"> </el-date-picker>
            </el-form-item>
            <el-form-item label="票号：" prop="ticketNumber">
              <el-input v-model="fromDate.ticketNumber" style="width: 340px" clearable placeholder="请输入" @blur="fromDate.ticketNumber = $regExp.enableSpace(fromDate.ticketNumber)" />
            </el-form-item>
            <el-form-item label="是否红冲：" prop="sureHongchong">
              <el-radio v-model="fromDate.sureHongchong" :label="1">是</el-radio>
              <el-radio v-model="fromDate.sureHongchong" :label="0">否</el-radio>
            </el-form-item>
            <template v-if="fromDate.sureHongchong">
              <el-form-item label="红冲类型：" prop="hongchongType">
                <el-radio v-model="fromDate.hongchongType" :label="1">本月</el-radio>
                <el-radio v-model="fromDate.hongchongType" :label="2">往期</el-radio>
              </el-form-item>
              <el-form-item label="被红冲的蓝字票号：" prop="hongchongTicketNember">
                <el-input v-model="fromDate.hongchongTicketNember" style="width: 340px" clearable placeholder="请输入" />
              </el-form-item>
            </template>
            <el-form-item label="发票金额(含税价)：" prop="invoiceAmount">
              <el-input
                v-model="fromDate.invoiceAmount"
                style="width: 340px"
                clearable
                placeholder="请输入"
                onkeypress="return( /\d|\.|\-/.test(String.fromCharCode(event.keyCode)))"
                @blur="fromDate.invoiceAmount = blurCheckNum(fromDate.invoiceAmount, true)"
              />
            </el-form-item>
            <el-form-item label="发票类型：" prop="invoiceCategoryId">
              <el-select v-model="fromDate.invoiceCategoryId" style="width: 340px" placeholder="请选择" @change="() => (fromDate.invoiceCategory = categoryType.find(c => c.value == fromDate.invoiceCategoryId).name)">
                <el-option v-for="(item, index) in categoryType" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="*附件：">
              <FileComponent fileCode="engineeringNotesFile" :disabled="modifyType" :files="files" :message="'选择附件（请上传PDF版发票）'" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model="fromDate.remark" style="width: 340px" clearable placeholder="请输入" />
            </el-form-item>
          </template>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addcardSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import FileComponent from "@/components/File/fileComponent";
// import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
// import { getDicsType } from "@/api/common.js";
// import { getUserInfo } from "@/utils/auth"
import { orgUserTree } from "@/api/common.js";
import { queryPage, Download, queryEngineering, queryInvoicedAmount, saveOrUpdate, deleteNotes } from "@/api/internetSales/engineeringNotes.js";
export default {
  mixins: [mixin],
  components: { FileComponent },
  data() {
    return {
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      DownloadURL: Download,
      saveOrUpdate: saveOrUpdate,
      batchUpdateOrDelete: deleteNotes,
      /*表格数据*/
      table: [
        { label: "票号", width: "120", prop: "ticketNumber", status: true },
        { label: "工程名称", width: "120", prop: "engineeringName", status: true },
        { label: "财务编码", width: "145", prop: "financialCode", status: true },
        { label: "共享项目编码", width: "145", prop: "shareProductCode", status: true },
        { label: "共享明细客户编码", width: "140", prop: "shareClientCode", status: true },
        { label: "开票人", width: "140", prop: "saller", status: true },
        { label: "创建人", width: "140", prop: "createUserName", status: true },
        { label: "修改人", width: "140", prop: "updateUserName", status: true },
        { label: "处别", width: "140", prop: "sallerDivision", status: true },
        { label: "合同单位", width: "120", prop: "contractUnit", status: true },
        { label: "合同签订主体", width: "120", prop: "contractSigningEntity", status: true },
        { label: "开票主体", width: "120", prop: "invoicingSubject", status: true },
        { label: "已开票金额", width: "120", prop: "invoiceAssembleAmount", status: true },
        { label: "不含税金额", width: "120", prop: "amountExcludingTax", status: true },
        { label: "税额", width: "120", prop: "taxAmount", status: true },
        { label: "月份", width: "120", prop: "invoicingMonth", status: true },
        { label: "日期", width: "120", prop: "invoicingData", status: true },
        { label: "是否红冲", width: "120", prop: "sureHongchong", status: true },
        { label: "红冲类型", width: "120", prop: "hongchongType", status: true },
        { label: "被红冲的蓝字票号", width: "120", prop: "hongchongTicketNember", status: true },
        { label: "发票金额（含税价）", width: "120", prop: "invoiceAmount", status: true },
        { label: "发票类型", width: "120", prop: "invoiceCategory", status: true },
        { label: "附件", width: "120", prop: "annexName", status: true },
        { label: "备注", width: "120", prop: "remark", status: true },
        { label: "状态", width: "120", prop: "dataStatus", status: true },
        { label: "操作", width: "240", prop: "", status: true },
      ],
      pagesType: 0,
      isDetails: false,
      modifyType: false,
      cascaderLoading: false,
      fromDate: {},
      low: {},
      categoryType: [
        { value: "1", name: "纸质专票" },
        { value: "2", name: "纸质普票" },
        { value: "3", name: "电子专票" },
        { value: "4", name: "电子普票" },
      ],
      engineeringNameList: [], //工程名称列表
      files: [],
      principalarr: [],
      startTimDateEndTimDate: [],
      startTimDateEndTimDate2: [],
    };
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.startMonth = val[0];
        this.tableParam.endMonth = val[1];
      } else {
        this.tableParam.startMonth = "";
        this.tableParam.endMonth = "";
      }
    },
    startTimDateEndTimDate2(val) {
      if (val?.length > 0) {
        this.tableParam.startInvoicingData = val[0];
        this.tableParam.endInvoicingData = val[1];
      } else {
        this.tableParam.startInvoicingData = "";
        this.tableParam.endInvoicingData = "";
      }
    },
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = {
      ...this.tableParam,
      startInvoiceAmount: "",
      endInvoiceAmount: "",
      billIssuedTotalMoney: "",
      invoiceAmount: "",
      saller: "",
      engineeringName: "",
      ticketNumber: "",
      invoicingMonth: "",
      startMonth: "",
      endMonth: "",
      financialCode: "",
      startInvoicingData: "",
      endInvoicingData: "",
      contractUnit: "",
    };
    this.gettableData();
    this.queryEngineering();
    this.principalarr = await orgUserTree("", 1);
    this.cascaderLoading?.close();
  },
  computed: {
    rules() {
      const commonRules = {
        engineeringId: [{ required: true, message: "请选择工程履约的工程", trigger: "change" }],
        invoicingMonth: [{ required: true, message: "请选择年月", trigger: "change" }],
        invoicingData: [{ required: true, message: "请选择日期", trigger: "change" }],
        ticketNumber: [{ required: true, message: "请输入", trigger: "blur" }],
        invoicedAmount: [{ required: true, message: "请输入已开票金额", trigger: "blur" }],
        invoicingSubject: [{ required: true, message: "请输入开票主体", trigger: "blur" }],
        sureHongchong: [{ required: true, message: "请选择", trigger: "change" }],
        hongchongType: [{ required: true, message: "请选择红冲类型", trigger: "change" }],
        hongchongTicketNember: [{ required: true, message: "请输入", trigger: "blur" }],
        invoiceCategoryId: [{ required: true, message: "请选择发票类型", trigger: "change" }],
      };

      const negativeNumberRule = {
        invoiceAmount: [
          { required: true, message: "请输入", trigger: "blur" },
          { pattern: /^-\d+(\.\d{1,2})?$/, message: "请输入负数或最多两位小数" },
        ],
      };

      const positiveNumberRule = {
        invoiceAmount: [
          { required: true, message: "请输入", trigger: "blur" },
          { pattern: /^\d+(\.\d{1,2})?$/, message: "请输入正数或最多两位小数" },
        ],
      };

      if (this.fromDate?.sureHongchong) {
        return { ...commonRules, ...negativeNumberRule };
      } else {
        return { ...commonRules, ...positiveNumberRule };
      }
    },
  },
  methods: {
    visibleChange() {
      let options = {
        target: ".loading", //你自定义的类名
        lock: true,
        text: "拼命加载中...",
        // background: 'rgba(0, 0, 0, 0.7)',
      };
      this.$nextTick(() => {
        if (this.principalarr.length == 0) {
          this.cascaderLoading = this.$loading(options);
          setTimeout(() => {
            this.cascaderLoading.close();
          }, 15000); // 设置遮罩层关闭时间 一般为接口超时时间
        }
      });
    },
    changeSaller() {
      this.$nextTick(() => {
        this.fromDate.saller = this.$refs.sallerId.presentText;
      });
    },
    addcardSure() {
      var FileType = false;
      if (this.files.length == 0) {
        FileType = true;
      }
      if (this.isDetails) {
        if (this.fromDate.ticketNumber == this.fromDate.hongchongTicketNember) {
          this.$message.warning("票号和被红冲的蓝字票号重复，请修改！");
          return;
        }
        if (FileType) {
          this.$message.warning({
            message: "请上传附件",
            type: "warning",
          });
        } else {
          this.$refs["reffromDate"].validate(valid => {
            if (!valid) return false;
            this.fromDate = { ...this.fromDate, invoiceAssembleAmount: this.invoicedAmount };
            if (this.isDetails) {
              this.fromDate.operate = 2;
            } else {
              this.fromDate.operate = 1;
            }
            this.submitFromDate();
          });
        }
      } else {
        this.$refs["reffromDate"].validate(valid => {
          if (!valid) return false;
          this.fromDate = { ...this.fromDate, invoiceAssembleAmount: this.invoicedAmount };
          if (this.isDetails) {
            this.fromDate.operate = 2;
          } else {
            this.fromDate.operate = 1;
          }
          this.submitFromDate();
        });
      }
    },
    calculateTax() {
      // 获取已开票金额和税率，如果没有值则默认为 0
      const invoicedAmount = Number(this.fromDate.invoicedAmount || 0);
      const taxRate = Number(this.fromDate.taxRate || 0); 
      console.log("已开票金额：" + invoicedAmount + "税率：" + taxRate);
      // 允许 invoicedAmount 为负数（支持红冲），只要不为 0 且税率大于 0 即可计算
      if (invoicedAmount !== 0 && !isNaN(invoicedAmount) && taxRate > 0) {
        // 不含税金额 = 已开票金额 / (1 + 税率)
        const amountExcludingTax = invoicedAmount / (1 + taxRate);
        // 税额 = 已开票金额 - 不含税金额
        const taxAmount = invoicedAmount - amountExcludingTax;
        
        // 使用 $set 赋值并保留两位小数，确保弹窗内的视图自动更新
        this.$set(this.fromDate, 'amountExcludingTax', amountExcludingTax.toFixed(2));
        this.$set(this.fromDate, 'taxAmount', taxAmount.toFixed(2));
      } else {
        // 数据不全或等于 0 时清空视图
        this.$set(this.fromDate, 'amountExcludingTax', '');
        this.$set(this.fromDate, 'taxAmount', '');
      }
    },
    queryInvoicedAmount(id) {
      queryInvoicedAmount({ engId: id }).then(res => {
        if (res.code === 1001) {
          this.invoicedAmount = res.data;
          this.$set(this.fromDate, "invoicedAmount", res.data);
          this.calculateTax();
        }
      });
    },
    //获取工程列表
    queryEngineering() {
      queryEngineering({ isMainEngineering: 1 }).then(res => {
        if (res.code == 1001) {
          this.engineeringNameList = [
            {
              engineeringName: "公司机关",
              engineeringId: "1",
            },
          ];
          if (res.data.length > 0) {
            this.engineeringNameList = [...this.engineeringNameList, ...res.data];
          }
        }
      });
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      this.files = [];
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        // createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.fromDate.annexName = data.fileName;
      this.fromDate.annexUrl = data.fileUrl;
      this.files.push(params);
    },
    // 修改销售详情
    addOtherCard(row) {
      this.files = [];
      this.fromDate = {};
      this.isDetails = true;
      if (row.annexName && row.annexUrl) {
        const params = {
          name: row.annexName,
          fileName: row.annexName,
          fileUrl: row.annexUrl,
          path: row.annexUrl,
          fileType: 1,
          type: 1,
        };
        this.files.push(params);
      }
      row.sureHongchong = row.sureHongchong ? row.sureHongchong : 0; // 是否红冲默认为否
      row.invoicedAmount = row.invoiceAssembleAmount; // 开票金额
      this.$set(this.rules, "invoiceAmount", undefined);
      this.updateFromDate(row, "发票出具");
    },
    // 新增
    addcard() {
      this.fromDate = {};
      this.isDetails = false;
      this.$nextTick(() => {
        this.$refs["reffromDate"].clearValidate();
      });
      this.addFromDate("发票出具");
    },
    // 修改财务
    lookcard(row) {
      this.fromDate = {};
      this.isDetails = false;
      row.invoicedAmount = row.invoiceAssembleAmount; // 开票金额
      this.updateFromDate(row, "发票出具");
    },
    delHandler() {
      this.Delete();
    },
    changstatus(e) {
      const row = this.engineeringNameList.find(c => c.engineeringId == e);
      console.log(row);
      this.fromDate = { ...this.fromDate, ...row };
      console.log(this.fromDate);
      this.$set(this.fromDate, "invoicingSubject", this.fromDate.collaborationUnit || "");
      this.$set(this.fromDate, "contractSigningEntity", this.fromDate.collaborationUnit || "");
      this.$set(this.fromDate, "contractSigningEntityId", this.fromDate.collaborationUnitId || "");
      // if (this.fromDate.engineeringId != 1) {
      this.queryInvoicedAmount(e);
      // }
    },
    numFormat(num) {
      var res = num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
      return res;
    },
    chooseNav(index) {
      this.currenindex = index;
    },
    open(low, key, disabled) {
      this.low = this.copy(low);
      this.disabled = disabled;
      this[key] = true;
    },
    reset(key) {
      this[key] = false;
    },
    submit(key) {
      this[key] = false;
      this.gettableData();
    },
    blurCheckNum(e, negativeType) {
      if (!e) {
        return 0;
      }
      let num = 0;
      if (negativeType) {
        //是否判断负数格式！
        var regu = new RegExp(/^-?\d+(\.\d+)?$/);
        if (regu.test(e)) {
          num = e.split("-")[1];
        }
      }
      let re = new RegExp(/^((\\-)(0|[1-9]\d*)(\.\d{0,4}))|((0|[1-9]\d*)(\.\d{0,4}))?$/);
      if (!re.test(e)) {
        this.$message({
          message: "请输入正确数值！",
          type: "warning",
        });
        return 0;
      }
      let re0 = new RegExp(/^[0]*$/);
      console.log(num, num.toString().split(".").length, re0.test(num.toString().split(".")[0]), re0.test(num.toString().split(".")[1]), "**************");
      if (e.toString().split(".").length > 1 && re0.test(e.toString().split(".")[0]) && re0.test(e.toString().split(".")[1])) {
        
        this.$message({
          message: "请输入正确数值！",
          type: "warning",
        });
        return 0;
      } else if (num.toString().split(".").length > 1 && re0.test(num.toString().split(".")[0]) && re0.test(e.toString().split(".")[1])) {
        this.$message({
          message: "请输入正确数值！",
          type: "warning",
        });
        return "";
      }
      return e;
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam = {
        ...this.tableParam,
        startInvoiceAmount: "",
        endInvoiceAmount: "",
        billIssuedTotalMoney: "",
        invoiceAmount: "",
        saller: "",
        engineeringName: "",
        ticketNumber: "",
        invoicingMonth: "",
        startMonth: "",
        endMonth: "",
        financialCode: "",
        startInvoicingData: "",
        endInvoicingData: "",
        contractUnit: "",
      };
      this.startTimDateEndTimDate2 = [];
      this.startTimDateEndTimDate = [];
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.tabtop {
  width: 381px;
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.reffromDom {
  max-height: 600px;
  overflow: auto;
}

.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.7;
}
</style>
